var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 17.81c.66-.73 1.16-1.58 1.52-2.54.35-.96.53-1.95.53-2.95 0-2.32-.81-4.28-2.43-5.89s-3.59-2.41-5.91-2.41-4.28.8-5.89 2.41C4.81 8.04 4.01 10 4.01 12.32s.81 4.28 2.43 5.89c1.62 1.61 3.59 2.41 5.91 2.41.98 0 1.95-.17 2.91-.51.96-.34 1.81-.84 2.54-1.5l9.37 9.37.84-.84-9.4-9.33Zm-1.13-.38c-1.39 1.38-3.1 2.07-5.12 2.07s-3.73-.69-5.12-2.07-2.09-3.08-2.09-5.1.7-3.73 2.09-5.12c1.39-1.39 3.1-2.09 5.12-2.09s3.73.7 5.12 2.09c1.39 1.39 2.09 3.1 2.09 5.12s-.7 3.73-2.09 5.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.15e1a29cf93b84bca1cc2750749d0905.svg";
export { ForwardRef as ReactComponent };